
import React from "react";
import ReactDOM from "react-dom";
import App from "./components/basket.mjs";
import {PubSub} from './weave/helpers.mjs';
import {isLibraryUser} from './helpers.mjs';

// import {ErrorNotification, LoadingNotification} from "./modal.js";
// import {isLibraryUser} from "./helpers.mjs";


function loadBasketDraw() {
    PubSub.pub("legacyReloadBaskets");
}

function loadOrderingGrid(basketId, productId) {
    if (!isLibraryUser()) {
        return;
    }
    PubSub.pub("loadOrderingGrid", basketId, productId);
}

function openAddBasketAfterBasketBuilder(basketType, basketId, productId, bookshelfId=0, basketBuilderData=[]) {
    if (isLibraryUser()) {
        if (basketType == "regular") {
            PubSub.pub("openOrderingGrid", basketId, productId, bookshelfId, basketBuilderData);
        } else if (basketType == "forSchools") {
            PubSub.pub("openAddForSchoolBasketModal", basketType, basketBuilderData);
        }
    } else {
        PubSub.pub("openAddBasketModal", basketType, basketBuilderData);
    }
}

window.loadBasketDraw = loadBasketDraw;
window.loadOrderingGrid = loadOrderingGrid;
window.openAddBasket = openAddBasketAfterBasketBuilder;

// ReactDOM.render(<React.StrictMode><App /></React.StrictMode>, document.getElementById("commonModals"));
ReactDOM.render(<App />, document.getElementById("commonModals"));